/* eslint-disable */
import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './views/Login/Login';
import LoginAdmin from './views/Login/LoginAdmin';
import LoginEEntry from './views/Login/Login E-Entry';
import LoginAdminEEntry from './views/Login/LoginAdmin E-Entry';
import LoginAdminEDonation from './views/Login/LoginEDonation';
import ProtectedRoutes from './contexts/ProtectedRoutes';
import ProtectedRoutesEEntry from './contexts/ProtectedRoutesEEntry';
import { AuthLayout, DashboardLayout } from './layouts';
import AuthProvider from './contexts/AuthContext';
import NotFound from './components/NotFound/NotFound';
import { checkAccessRights } from './utils/functions/accessRight';
import { checkAccessRightsEEntry } from './utils/functions/accessRightEEntry';
import { getSystem } from './utils/functions/accessRight';
import { removeStorage } from './utils/functions/localstorage';
import { getSystems } from './utils/functions/accessRightEEntry';
import { ROLES } from './utils/constants';

import HistorySuperAdmin from './views/HistorySuperAdmin';
import TransactionResult from './views/TransactionResult';
import PaymentOptions from './views/PaymentOptions';
import StoreManagement from './views/StoreManagement';
import ManagementSuperAdmin from './views/UserManagement/ManagementSuperAdmin';
import ManagementAdmin from './views/UserManagement/ManagementAdmin';
import PendingSuperAdmin from './views/PendingSuperAdmin';
import ApproveSuperAdmin from './views/ApproveSuperAdmin';
import RejectSuperAdmin from './views/RejectSuperAdmin';
import RecipientReport from './views/RecipientReport';

import HistoryAdmin from './views/HistoryAdmin';
import PendingAdmin from './views/PendingAdmin';
import ApproveAdmin from './views/ApproveAdmin';
import RejectAdmin from './views/RejectAdmin';

import CallURL from './views/Callurl';
import HttpStatus from './views/HttpStatus';
import Maintenance from './views/Maintenance';
import Setting from './views/Setting/Setting';

import CreatePayment from './views/E-Entry/User/CreatePayment';
import Donation from './views/E-Entry/User/Donation';
import QRCode from './components/PayOptionE-Entry/QRCode';
import QRCodeEducation from './components/PayOptionE-Entry/QRCodeEducation';
import QRCreit from './components/PayOptionE-Entry/QRCredit';
import LinkCashier from './components/PayOptionE-Entry/LinkCashier';
import TransactionResultEEntry from './views/TransactionResultEEntry';
import TransactionResultEDonation from './views/TransactionResultEDonation';
import ManagementAdminEEntry from './views/UserManagement/ManagementAdminEEntry';
import ManagementSuperAdminEEntry from './views/UserManagement/ManagementSuperAdminEEntry';
import History from './views/E-Entry/History';
import Config from './views/E-Entry/Config';
import { getStorage } from './utils/functions/localstorage';
import { useNavigate } from 'react-router-dom';

import Swal from 'sweetalert2';

const INACTIVITY_LIMIT = 20 * 60 * 1000; // 20 นาที
let inactivityTimer = null;

function startInactivityWatcher(handleLogout) {
  const actions = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

  const resetTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      const token = getStorage('token');
      if (token) {
        handleLogout();
      }
    }, INACTIVITY_LIMIT);
  };

  actions.forEach((action) => {
    window.addEventListener(action, resetTimer);
  });

  resetTimer(); // เริ่มจับเวลาเมื่อโหลด
}

function AppWrapper({ children }) {
  const Systems = getSystem(); // 'cashier' หรือ 'eentry'
  const navigate = useNavigate();

  const handleLogout = React.useCallback(() => {
    if (window.hasLoggedOut) return;
    window.hasLoggedOut = true;

    // ลบ token ทันที และตั้ง flag เพื่อแสดง Swal ที่หน้า login
    removeStorage('token');
    localStorage.setItem('sessionExpired', '1');

    if (Systems === 'cashier') {
      navigate('/login');
    } else if (Systems === 'eentry') {
      navigate('/e-entry/login');
    } else {
      navigate('/login');
    }
  }, [navigate, Systems]);

  React.useEffect(() => {
    const token = getStorage('token');
    if (token) {
      startInactivityWatcher(handleLogout);
    }

    // fallback: ตรวจสอบทุก 5 นาที เผื่อ token ถูกลบจาก devtools
    const interval = setInterval(
      () => {
        const stillValid = getStorage('token');
        if (!stillValid && token) {
          handleLogout();
        }
      },
      1000 * 60 * 20,
    );

    return () => clearInterval(interval);
  }, [handleLogout]);

  return <>{children}</>;
}

function App() {
  const EDonation = getStorage('eDoanation');
  const System = getSystem();

  const renderRouterFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE) && EDonation === 'E-Donation') {
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index path="/" element={<Donation />} />
          {/* <Route path="/History" element={<History />} /> */}
          <Route path="/CreatePayment" element={<CreatePayment />} />
          <Route path="/QrCodeEducation" element={<QRCodeEducation />} />
          <Route path="/QRCreit" element={<QRCreit />} />
          <Route path="/LinkCashier" element={<LinkCashier />} />
          <Route path="/donation" element={<Donation />} />

          <Route
            path="/transactionResultEDonation"
            element={<TransactionResultEDonation />}
          />
        </Route>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE) && System === 'ecashier') {
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index path="/" element={<HistoryAdmin />} />
          <Route path="/history-dadmin" element={<HistorySuperAdmin />} />
        </Route>
      );
    }

    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'ecashier') {
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index path="/" element={<HistoryAdmin />} />
          <Route path="/history-admin" element={<HistoryAdmin />} />
          <Route path="/pending-admin" element={<PendingAdmin />} />
          <Route path="/approve-admin" element={<ApproveAdmin />} />
          <Route path="/reject-admin" element={<RejectAdmin />} />
        </Route>
      );
    }

    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) && System === 'ecashier') {
      return (
        <>
          <Route
            path="/"
            element={<DashboardLayout checkAccessRights={checkAccessRights} />}
          >
            <Route index path="/" element={<HistorySuperAdmin />} />
            <Route path="/history-superadmin" element={<HistorySuperAdmin />} />
            <Route path="/pending-superadmin" element={<PendingSuperAdmin />} />
            <Route path="/approve-superadmin" element={<ApproveSuperAdmin />} />
            <Route path="/reject-superadmin" element={<RejectSuperAdmin />} />
            <Route path="/merchant-management" element={<StoreManagement />} />
            <Route path="/super-admin" element={<ManagementSuperAdmin />} />
            <Route path="/admin" element={<ManagementAdmin />} />
            <Route path="/CreatePayment" element={<CreatePayment />} />
            <Route path="/QrCode" element={<QRCode />} />
            <Route path="/QRCreit" element={<QRCreit />} />
            <Route path="/LinkCashier" element={<LinkCashier />} />
            <Route path="/History" element={<History />} />
            <Route path="/RecipientReport" element={<RecipientReport />} />
            <Route
              path="/transactionResultEEntry"
              element={<TransactionResultEEntry />}
            />
            <Route path="/setting" element={<Setting />} />
          </Route>
        </>
      );
    }

    if (checkAccessRights(ROLES.USER_ROLE) && System === 'eentry') {
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index path="/" element={<History />} />
          <Route path="/History" element={<History />} />
          <Route path="/CreatePayment" element={<CreatePayment />} />
          <Route path="/QrCode" element={<QRCode />} />
          <Route path="/QRCreit" element={<QRCreit />} />
          <Route path="/LinkCashier" element={<LinkCashier />} />
          <Route
            path="/transactionResultEEntry"
            element={<TransactionResultEEntry />}
          />
        </Route>
      );
    }

    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'eentry') {
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index path="/" element={<History />} />
          <Route path="/History" element={<History />} />
          <Route path="/CreatePayment" element={<CreatePayment />} />
          <Route path="/QrCode" element={<QRCode />} />
          <Route path="/QRCreit" element={<QRCreit />} />
          <Route path="/LinkCashier" element={<LinkCashier />} />
          <Route
            path="/transactionResultEEntry"
            element={<TransactionResultEEntry />}
          />
          <Route
            path="/ManagementAdminEEntry"
            element={<ManagementAdminEEntry />}
          />
        </Route>
      );
    }

    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) && System === 'eentry') {
      return (
        <>
          <Route
            path="/"
            element={<DashboardLayout checkAccessRights={checkAccessRights} />}
          >
            <Route index path="/" element={<History />} />
            <Route path="/History" element={<History />} />
            <Route path="/CreatePayment" element={<CreatePayment />} />
            <Route path="/QrCode" element={<QRCode />} />
            <Route path="/QRCreit" element={<QRCreit />} />
            <Route path="/LinkCashier" element={<LinkCashier />} />
            <Route
              path="/ManagementAdminEEntry"
              element={<ManagementAdminEEntry />}
            />
            <Route
              path="/ManagementSuperAdminEEntry"
              element={<ManagementSuperAdminEEntry />}
            />
            <Route
              path="/transactionResultEEntry"
              element={<TransactionResultEEntry />}
            />
            <Route path="/Config" element={<Config />} />
          </Route>
        </>
      );
    }
    return <Route path="/" element={<div />} />;
  };

  return (
    <AuthProvider>
      <AppWrapper>
        <Routes>
          <Route path="/login" element={<AuthLayout />}>
            <Route index element={<Login />} />
          </Route>
          <Route path="/login-admin" element={<AuthLayout />}>
            <Route index element={<LoginAdmin />} />
          </Route>
          <Route path="/e-entry/login" element={<AuthLayout />}>
            <Route index element={<LoginEEntry />} />
          </Route>
          <Route path="/e-entry/login-admin" element={<AuthLayout />}>
            <Route index element={<LoginAdminEEntry />} />
          </Route>
          <Route path="/e-entry/login-edonation" element={<AuthLayout />}>
            <Route index element={<LoginAdminEDonation />} />
          </Route>
          <Route path="/checkout" element={<PaymentOptions />} />
          <Route path="/httpStatus" element={<HttpStatus />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/transactionResult" element={<TransactionResult />} />
          <Route path="/callurl" element={<CallURL />} />
          <Route element={<ProtectedRoutes />}>
            {renderRouterFromAccessibleRole()}
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppWrapper>
    </AuthProvider>
  );
}

export default App;
